// Pace tracker.
// Parses [~MM:SS] markers from the current slide's notes — same convention as
// the original Voting Reforms deck. The first marker on each slide is its
// "expected elapsed time at this point". We compare to actual elapsed time
// (from session start) and flag if the speaker is running ahead/behind.

function parseTarget(html) {
  if (!html) return null;
  const m = html.match(/\[~\s*(\d+):(\d{2})\s*\]/);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
}

function fmt(seconds) {
  const sign = seconds < 0 ? '-' : '';
  seconds = Math.abs(Math.round(seconds));
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${sign}${m}:${String(s).padStart(2, '0')}`;
}

export default {
  id:   'pace-tracker',
  slot: 'pace-tracker',
  mount({ slot, deck }) {
    slot.innerHTML = `
      <div class="panel-header"><span>Pace</span><span data-role="started"></span></div>
      <div class="pace-body">
        <div class="pace-stat">
          <div class="label">Elapsed</div>
          <div class="value" data-role="elapsed">0:00</div>
        </div>
        <div class="pace-stat">
          <div class="label">Target</div>
          <div class="value" data-role="target">—</div>
        </div>
        <div class="pace-stat">
          <div class="label">Drift</div>
          <div class="value" data-role="drift">—</div>
        </div>
      </div>
    `;
    const elapsedEl = slot.querySelector('[data-role="elapsed"]');
    const targetEl  = slot.querySelector('[data-role="target"]');
    const driftEl   = slot.querySelector('[data-role="drift"]');
    const startedEl = slot.querySelector('[data-role="started"]');

    let startedAt = null;

    const tick = () => {
      if (!startedAt) return;
      const elapsed = (Date.now() - startedAt) / 1000;
      elapsedEl.textContent = fmt(elapsed);
      const target = parseTarget(deck.getCurrentNotes());
      if (target == null) {
        targetEl.textContent = '—';
        driftEl.textContent  = '—';
        driftEl.className    = 'value';
      } else {
        targetEl.textContent = fmt(target);
        const drift = elapsed - target; // positive = behind schedule
        driftEl.textContent = (drift >= 0 ? '+' : '') + fmt(drift);
        driftEl.className = 'value ' + (
          drift < -30 ? 'ahead' :
          drift <  30 ? '' :
          drift < 120 ? 'behind' :
                        'way-behind'
        );
      }
    };

    deck.onReady(() => {
      // Start the clock when the speaker advances off slide 0.
      const start = () => {
        if (startedAt) return;
        startedAt = Date.now();
        startedEl.textContent = 'started';
      };
      deck.reveal.on('slidechanged', (e) => {
        const i = e.indexh ?? 0;
        if (i > 0) start();
      });
      setInterval(tick, 200);
    });
  },
};
